var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anim-fade-in"},[_c('BuildingsTabs'),_c('div',_vm._l((_vm.items),function(item){return (!item.disabled)?_c('Building',{key:item.id,attrs:{"building":item}}):_vm._e()}))],1)}
var staticRenderFns = []

export { render, staticRenderFns }